import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import { useEmblaCarousel } from 'embla-carousel/react'
import { Link } from 'gatsby'

import { Image } from 'src/components/image'

import { Arrow } from 'src/components/svgs'

export interface FeaturedArticlesProps {
  data: {
    title?: string
    backgroundColor?: string
    articles: any[]
  }
}

export const FeaturedArticles = ({ data }: FeaturedArticlesProps) => {
  const { title, articles, spacing, backgroundColor } = data
  const [slide, setSlide] = useState(1)

  const [EmblaCarouselReact, embla] = useEmblaCarousel({
    loop: true,
    containScroll: false,
    slidesToScroll: 1,
    align: 'center',
    speed: 10,
    containerSelector: '*',
    startIndex: 0,
  })

  useEffect(() => {
    if (embla) {
      embla.on('select', () => {
        setSlide(embla.selectedScrollSnap() + 1)
      })
    }
  }, [embla])

  return (
    <div
      className={cx('embla  rel', backgroundColor, spacing, {
        cw: backgroundColor === 'bcb',
        'cw bcb': backgroundColor === undefined,
      })}
    >
      <div className="container--l  outer article__card  embla__viewport mxa py2 p1 al x">
        {title && <h2 className="module-title-serif">{title}</h2>}

        <EmblaCarouselReact>
          <div className="f x article__slideshow rel embla__container">
            {articles?.map(article => {
              const {
                content: {
                  main: {
                    title,
                    articleColor,
                    subTitle,
                    articleType,
                    slug,
                    cardImage,
                    authors,
                    image,
                  },
                },
              } = article
              return (
                <div
                  key={article._id}
                  className={cx(
                    'f x jcb fw jcrr embla__slide article__card-single cursor aist',
                    articleColor
                  )}
                >
                  <Link
                    aria-label="carousel item"
                    to={`/article/${slug.current}/`}
                    className="abs z1 top left x y"
                  />
                  <div className="article__card-image rel col-m-6 x">
                    {cardImage ? (
                      <Image
                        className="x"
                        imageId={cardImage.asset._id}
                        raw={cardImage}
                        size={800}
                        alt={title}
                      />
                    ) : (
                      <Image
                        className="x"
                        imageId={image.asset._id}
                        alt={title}
                      />
                    )}
                  </div>
                  <div className="article__card-text f jcb fw p1 col-m-4 x">
                    <div>
                      {articleType && (
                        <h5 className="caps mono m0 pb1 pt0">
                          {articleType.title}
                        </h5>
                      )}
                      <h3 className="m0 py0">{title}</h3>
                      {subTitle && <h4 className="m0 pb0 pt1">{subTitle}</h4>}
                      {/*authors && authors.length > 0 && (
                        <span className='mt1 block'>{authors[0].content.main.title}, {authors[0].content.main.position}</span>
                      ) */}
                    </div>
                    <div style={{ marginTop: '30px' }}>
                      <Link to={`/article/${slug.current}/`} className="button">
                        Read more
                      </Link>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          {articles.length > 1 && (
            <div
              className={cx('pt1 f jcs image__carousel-controls aic', {
                cw: backgroundColor === 'bcb',
              })}
            >
              <button
                aria-label="carousel arrow"
                className={cx('no-style', {
                  cw: backgroundColor === 'bcb',
                })}
                onClick={() => embla.scrollPrev()}
              >
                <Arrow />
              </button>
              {articles.length < 6 ? (
                <div className="m1 carousel__dots f jcc aic">
                  {articles?.map((item, i) => (
                    <span
                      onClick={() => embla.scrollTo(i)}
                      key={i}
                      className={cx('dot block', {
                        'is-active': slide - 1 === i,
                      })}
                    />
                  ))}
                </div>
              ) : (
                <span className=" block m1">
                  {slide}/{articles.length}
                </span>
              )}
              <button
                aria-label="scroll next"
                className={cx('no-style arrow__rotate', {
                  cw: backgroundColor === 'bcb',
                })}
                onClick={() => embla.scrollNext()}
              >
                <Arrow />
              </button>
            </div>
          )}
        </EmblaCarouselReact>
      </div>
    </div>
  )
}

export default FeaturedArticles
